/**
 * Pré-carrega o código de todas as telas com o navegador ocioso, logo depois que a sessão
 * abre. Sem isto, a PRIMEIRA visita a cada tela esperava o download do código dela e a área
 * de conteúdo ficava vazia por um instante. As importações são as mesmas dos `lazy()` das
 * rotas (src/app), então o bundler reaproveita os mesmos pedaços.
 */
const TELAS_COLABORADOR = [
  () => import("@/screens/Home"),
  () => import("@/screens/Justificativas"),
  () => import("@/screens/Arquivos"),
  () => import("@/screens/Camera"),
  () => import("@/screens/Registro"),
  () => import("@/screens/Espelho"),
  () => import("@/screens/AtestadoMedico"),
  () => import("@/screens/SolicitacaoAbono"),
  () => import("@/screens/Notificacoes"),
  () => import("@/screens/Checklists"),
  () => import("@/screens/LivroOcorrencia"),
  () => import("@/screens/OrdemServico"),
  () => import("@/screens/Ronda"),
  () => import("@/screens/Estoque"),
  () => import("@/screens/Treinamentos"),
  () => import("@/screens/MeusDados"),
  () => import("@/screens/Biometria"),
  () => import("@/screens/SuporteChat"),
  () => import("@/screens/AtualizacaoCadastral"),
  () => import("@/screens/BiometricSetup"),
  () => import("@/screens/Assinatura"),
];

let feito = false;

const ocioso = (fn: () => void) =>
  typeof requestIdleCallback === "function" ? requestIdleCallback(fn, { timeout: 4000 }) : setTimeout(fn, 1200);

export function precarregarTelas(): void {
  if (feito) return;
  feito = true;
  // Uma tela por vez, sempre no ocioso: não disputa rede/CPU com a tela que está abrindo.
  let i = 0;
  const proxima = () => {
    if (i >= TELAS_COLABORADOR.length) return;
    const carregar = TELAS_COLABORADOR[i++];
    carregar()
      .catch(() => {})
      .finally(() => ocioso(proxima));
  };
  ocioso(proxima);
}
